import styled from 'styled-components/macro'

export const UserExistsError = styled.div`
  display: none;
  color: #ff0000;
  font-size: 15px;
  letter-spacing: -0.075em;

  &.error {
    margin-bottom: 10px;
    display: block;
    text-align: center;
  }
`

export const HiddenEmail = styled.div`
  display: none;
`
